export class SubstanceAbuseTreatmentReferral {
  id?: number;

  date!: Date;
  offenderNumber!: string;
  offenderName!: string;
  offenderDateOfBirth!: Date;
  offenderAddress!: string;
  offenderCity!: string;
  offenderState!: string;
  offenderZipCode!: string;
  offenderPhone!: string;
  supervisingAgentName!: string;
  supervisingAgentEmail?: string;
  supervisingAgentPhone?: string;
  supervisorName!: string;
  supervisorEmail?: string;
  supervisorPhone?: string;

  primaryDrug!: string;
  primaryDrugOther?: string;
  primaryDrugAdministrationMethod!: string;
  primaryDrugLastUse!: Date;
  primaryDrugFrequency!: string;

  secondaryDrug?: string;
  secondaryDrugOther?: string;
  secondaryDrugAdministrationMethod?: string;
  secondaryDrugLastUse?: Date;
  secondaryDrugFrequency?: string;

  hasDesireForTreatment: boolean = false;
  hasRecentFailedSubstanceTest: boolean = false;
  hasFamilyExpressedConcern: boolean = false;
  hasRecentFailedTreatment: boolean = false;
  recentFailedTreatmentDate?: Date;
  hasRecentSubstanceArrest: boolean = false;
  hasOtherSubstanceAbuseIssue: boolean = false;
  otherSubstanceAbuseIssue?: string;

  outpatientTreatmentReceived: boolean = false;
  outpatientTreatmentAmount?: number;
  outpatientTreatmentDates?: string;
  residentialTreatmentReceived: boolean = false;
  residentialTreatmentAmount?: number;
  residentialTreatmentDates?: string;

  otherOffenseHistory?: string;

  currentMedicalCondition?: string;
  currentMedicalConditionOther?: string;
  psychiatricProblemsExist: boolean = false;
  psychiatricProblemDetails?: string;
  onMedication: boolean = false;
  medicationDetails?: string;
  medicationHasThirtyDaySupply: boolean = false;
  medicationIsImmediatelyAvailable: boolean = false;
  medicationAvailableDate?: Date;
}
